<template>
  <div>
    <div class="board-view" v-if="isJobs">
      <table class="board-view-table">
        <thead>
          <tr>
            <th>
              <div>
                <dl>
                  <dt>[{{ detail.title }}]</dt>
                  <dd>{{ detail.subTitle }}</dd>
                </dl>
                <p>{{ detail.subTitleContent }}</p>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div v-html="detail.content"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="board-view-bottom">
        <v-btn x-large rounded depressed color="secondary" class="mr-2" @click.prevent="moveList"
        :data-ga-category="gaEvent.category.career.jobDetail.name" :data-ga-label="gaEvent.category.career.jobDetail.label1" :data-ga-action="gaEvent.actions.buttonClick">목록</v-btn>
        <v-btn x-large rounded depressed color="primary" @click.prevent="apply"
        :data-ga-category="gaEvent.category.career.jobDetail.name" :data-ga-label="gaEvent.category.career.jobDetail.label2" :data-ga-action="gaEvent.actions.buttonClick">지원하기</v-btn>
      </div>
    </div>
    <div class="board-view" v-if="isNotice">
      <table class="board-view-table">
        <thead>
          <tr>
            <th>
              <div>
                <dl>
                  <dt>{{ detail.title }}</dt>
                </dl>
                <p>
                  {{ detail.updUserId }}
                  <span class="mx-3">|</span>
                  <time :datetime="detail.updDt">{{ moment(detail.updDt).format("YYYY-MM-DD") }}</time>
                </p>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div v-html="detail.content"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="board-view-bottom">
        <v-btn x-large rounded depressed color="secondary" class="mr-2" @click.prevent="$router.go(-1)">목록</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {GaTracking} from "@/mixins/index.js";
export default {
  mixins: [GaTracking],
  name: "BoardView",
  components: {},
  props: {
    detail: {
      type: Object,
      default: function() {
        return {};
      }
    },
    category: {
      type: String,
      default: "jobs" //or "notice"
    }
  },
  data() {
    return {};
  },
  computed: {
    isNotice() {
      return this.category === "notice";
    },
    isJobs() {
      return this.category === "jobs";
    }
  },
  watch: {},
  methods: {
    moveList(e){
      this.gaTracking(e);
      this.$router.go(-1);
    },
    apply(e){
      this.gaTracking(e);
      window.location = "mailto:hr@finbridge.co.kr";
    },

  },
  created() {}
};
</script>

<style lang="scss" scoped>
.board-view {
  &-table {
    width: 100%;
    border-collapse: collapse;
    thead {
      th {
        border-top: 2px solid $text-color;
        border-bottom: 1px solid #e5e5e5;
        padding: 24px 8px;
        font-weight: 400;
        text-align: left;
        > div {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          dl {
            display: block;
            font-size: rem(18px);
            letter-spacing: -1px;
            dt {
              margin-right: 4px;
            }
          }
          p {
            font-size: rem(13px);
            color: #888888;
            margin-top: 8px;
          }
        }
      }
    }
    tbody {
      td {
        border-bottom: 1px solid #e5e5e5;
        padding: 32px 8px;
        font-size: rem(13px);
        line-height: rem(22px);
        word-break: keep-all;
        
      }
    }
  }
  &-bottom {
    margin-top: 16px;
    text-align: right;
    .v-btn {
      font-size: rem(13px);
      height: 40px;
    }
  }

  @include respond-to("small") {
    &-table {
      width: 100%;
      border-collapse: collapse;
      thead {
        th {
          > div {
            dl {
              display: flex;
              font-size: rem(21px);
              dt {
                margin-right: 8px;
              }
            }
            p {
              font-size: rem(16px);
            }
          }
        }
      }
      tbody {
        td {
          padding: 32px 16px;
          font-size: rem(16px);
          line-height: rem(24px);
        }
      }
    }
  }
  @include respond-to("medium") {
    &-table {
      thead {
        th {
          > div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            dl {
              display: flex;
              font-size: rem(24px);
              dt {
                margin-right: 8px;
              }
            }
            p {
              font-size: rem(18px);
              margin-top: 0;
            }
          }
        }
      }
      tbody {
        td {
          padding: 96px 48px;
          font-size: rem(18px);
          line-height: rem(30px);
        }
      }
    }
    &-bottom {
      margin-top: 30px;
      .v-btn {
        font-size: rem(16px);
        height: 52px;
      }
    }
  }
}

::v-deep {
  ul {
    margin-left: 18px !important;
  }
}

</style>